export default {
      id: "card-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#card",
      toString: function () {
        return this.url;
      }
    }